import { useMemo } from 'react';
var generateId = function generateId() {
  return "input_".concat(Math.random().toString().split('.')[1].substr(-8));
};
export var useInputId = function useInputId(external) {
  var id = useMemo(function () {
    var result;
    if (external) {
      result = generateId();
    }
    if (typeof external === 'string') {
      result = external;
    }
    return result;
  }, [external]);
  return id;
};